import { render, staticRenderFns } from "./authcollapse2.vue?vue&type=template&id=47f8fd82&scoped=true&"
import script from "./authcollapse2.vue?vue&type=script&lang=js&"
export * from "./authcollapse2.vue?vue&type=script&lang=js&"
import style0 from "./authcollapse2.vue?vue&type=style&index=0&id=47f8fd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8fd82",
  null
  
)

export default component.exports